import {Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import * as _ from 'lodash';
import {ProfileListComponent} from '../profile-list/profile-list.component';
import {MODAL_CONFIG} from '../../../services/constant';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'profile-list-detail',
  templateUrl: './profile-list-detail.component.html',
  styleUrls: ['./profile-list-detail.component.scss']
})
export class ProfileListDetailComponent implements OnInit {
  modalRef: BsModalRef;
  user: any = {};
  groups: any = [];
  companygroups: any = {};
  companyGroupID = [];
  title = '';
  createMode = false;
  errorMessage: string = null;
  errorMsgForShow: string = null;
  errorMsgForShows: string = null;
  passwordPlaceHolder = '';
  parent: ProfileListComponent = null;
  checkUser = false;

  @ViewChild('modalTemplate') modalTemplate: TemplateRef<any>;

  constructor(private apiService: ApiService,
              private modalService: BsModalService,
              private translate: TranslateService) {
  }

  open(parent: ProfileListComponent, selectedUser) {
    this.parent = parent;
    this.errorMessage = null;

    if (selectedUser != null) {
      this.user = _.cloneDeep(selectedUser);
      this.user.group = this.user.group.id;
      delete this.user.status;
      this.createMode = false;
      this.companyGroupID = [];
      this.checkUser = true;
      this.title = this.translate.instant('PROFILE.LIST.MODAL.TITLE') + ' : ' + this.user.username;
      this.passwordPlaceHolder = '(' + this.translate.instant('PROFILE.LIST.MODAL.PASSWORD-PLACEHOLDER') + ')';
      if (this.user.company_group) {
        this.user.company_group.forEach(what => {
          this.companyGroupID.push(what.id);
        });
      }
    } else {
      this.user = {'group': this.groups[0]['value']};
      this.createMode = true;
      this.checkUser = false;
      this.title = this.translate.instant('PROFILE.LIST.MODAL.ADD-USER');
      this.passwordPlaceHolder = this.translate.instant('PROFILE.LIST.MODAL.PASSWORD');
    }

    this.modalRef = this.modalService.show(this.modalTemplate, MODAL_CONFIG);
  }

  ngOnInit() {
    this.loadGroups();
    this.loadCompanyGroups();
  }


  submit() {
    if (this.translate.currentLang !== 'en') {
      const errorField = [];
      this.errorMessage = null;

      if (this.user.username == null || this.user.username.length === 0) {
        errorField.push('ชื่อผู้ใช้งาน');
      }

      if (this.createMode && (this.user.password == null || this.user.password.length === 0)) {
        errorField.push('รหัสผ่าน');
      }

      if (this.createMode && (this.companyGroupID == null || this.companyGroupID.length == 0)) {
        errorField.push('บริษัท');
      }

      if (errorField.length > 0) {
        this.errorMessage = 'โปรดกรอก ' + errorField.join(', ') + ' ให้ถูกต้อง';
        return;
      }
    } else {
      const errorField = [];
      this.errorMessage = null;

      if (this.user.username == null || this.user.username.length === 0) {
        errorField.push('Username');
      }

      if (this.createMode && (this.user.password == null || this.user.password.length === 0)) {
        errorField.push('Password');
      }

      if (this.createMode && (this.companyGroupID == null || this.companyGroupID.length == 0)) {
        errorField.push('Company');
      }

      if (errorField.length > 0) {
        this.errorMessage = 'Please fill ' + errorField.join(', ') + ' correctly';
        return;
      }
    }

    this.user.company_group_id = this.companyGroupID;

    let request = null;

    if (this.createMode) {
      request = this.apiService.createUser(this.user);
      const role_name = this.groups.find(x => x.value === this.user.group).label;
      this.sniff('CREATE_USER', role_name + ': ' + this.user.username);
    } else {
      request = this.apiService.updateUser(this.user);
      this.sniff('UPDATE_USER',  this.title + ' to ' + this.user.username);
    }

    request.subscribe(
      (obj) => {
        this.parent.reload();
        this.modalRef.hide();
        this.clearData();
      },
      error => {
        this.checkErrorMsg(error);
      }
    );
  }

  checkErrorMsg(error) {
     this.errorMessage = this.apiService.getErrorMessage(error);
  }

  clearData() {
    this.user = {};
    this.companyGroupID = null;
    this.errorMsgForShow = null;
  }

  close() {
    this.modalRef.hide();
    this.clearData();
  }

  disableUser() {
    this.sniff('DISABLE_USER', this.user.username);
    const request = this.apiService.deleteUser(this.user);
    request.subscribe(
      (obj) => {
        this.parent.reload();
        this.modalRef.hide();
      },
      error => {
        this.checkErrorAllMsg(error);
      }
    );
  }

  checkErrorAllMsg(error) {
    this.errorMsgForShows = this.apiService.getErrorMessage(error);
    if (this.translate.currentLang === 'en') {
      this.errorMessage = this.errorMsgForShows[0];
    } else {
      this.errorMessage = this.errorMsgForShows[1];
    }
  }

  enableUser() {
    this.sniff('ENABLE_USER', this.user.username);
    this.user.is_active = true;
    this.user.company_group_id = this.companyGroupID;
    const request = this.apiService.updateUser(this.user);

    request.subscribe(
      (obj) => {
        this.parent.reload();
        this.modalRef.hide();
      },
      error => {
        this.errorMessage = this.apiService.getErrorMessage(error);
      }
    );
  }

  loadGroups() {
    this.groups = [];
    const params = {
      source: 'profile'
    };
    this.apiService.getRoles(params).subscribe(
      (groups) => {
        _.forEach(groups, (group) => {
          this.groups.push({
            'label': group['name'],
            'value': group['id']
          });
        });
      },
      error => {
        console.log('error', error);
      }
    );
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'MANAGE_USERS',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  loadCompanyGroups() {
    this.companygroups = [];

    this.apiService.getCompanyGroups().subscribe(
      (companygroups) => {
        _.forEach(companygroups, (company_group) => {
          this.companygroups.push({
            'label': company_group['company_group'],
            'value': company_group['id']
          });
        });
      },
      error => {
        console.log('error', error);
      }
    );
  }
}


// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list-detail/profile-list-detail.component.ts